import $ from "jquery";

const miCardTeam = () => {
    const init = () => {
        observeSection();
    }

    const observeSection = () => {
        const target = document.getElementById('section-step-animation');
        if (!target) return;



        const observer = new IntersectionObserver((entries, observerInstance) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    $('.js-CardTeam-wrapper').find(`.mi-CardTeam.delay-1`).addClass('active');
                    execute();

                    observerInstance.unobserve(target);
                }
            });
        }, {
            threshold: 0.2
        });

        observer.observe(target);
    };

    const execute = () => {
        const el = {
            main: '.js-CardTeam-wrapper'
        }
        if ($(el.main).length === 0) return

        const totalCard = 4
        let active = 1;



        setInterval(() => {
            if (active >= totalCard) active = 1
            else ++active


            $(el.main).find(`.mi-CardTeam`).removeClass('active')
            $(el.main).find(`.mi-CardTeam.delay-${active}`).addClass('active')
        }, 5000)

    }
    init()
}

try {
    miCardTeam()
} catch (error) {
    console.error('miCardTeam', error)
}